module.exports = __webpack_public_path__ + "static/biver-e03616a7a50891096ec0ec843eb81227.png";